export type PropertyType<T = any> = {
    editable?: boolean
    data?: T
}

export type DataFieldType = {
    [key: string]: PropertyType
}

export type DocumentType = {
    documentType: string
    documentId: string
    annotationFields?: DataFieldType[]
    presetFields?: DataFieldType[]
}

export type DocumentExtractionData = {
    documents: DocumentType[]
}

export enum FieldStatus {
    Active = "Active",
    Inactive = "Inactive"
}
